import SignupLegalUserSmallDown from '@/components/signup-legal-user/SignupLegalUserSmallDown'
import SignupLegalUserSmallUp from '@/components/signup-legal-user/SignupLegalUserSmallUp';
const SignupLegalUser = () => {
  return (
    <>
      <SignupLegalUserSmallUp />
      <SignupLegalUserSmallDown />
    </>
  )
}

export default SignupLegalUser
